<template>
  <div class="container-fluid py-4">
    <!-- Header moderne -->
    <div
      class="d-flex justify-content-between align-items-center mb-4 header-clinique"
    >
      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-pencil-square fs-2 text-primary"></i>
        <h2 class="fw-bold mb-0">Modification d'un Patient</h2>
      </div>
      <router-link
        class="btn btn-primary btn-lg shadow-sm btn-clinique"
        :to="{ name: 'patients' }"
      >
        <i class="bi bi-arrow-left-circle me-2"></i> Retour
      </router-link>
    </div>

    <!-- Card formulaire -->
    <!-- Card formulaire -->
    <div class="card p-4 shadow-sm rounded card-clinique">
      <div class="row g-4">
        <!-- Nom -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Nom</label>
          <input
            type="text"
            v-model="patient.nom"
            placeholder="Nom"
            class="form-control form-control-clinique"
            :class="{ 'is-invalid': error.nom }"
          />
          <div class="invalid-feedback">{{ error.nom }}</div>
        </div>
        <!-- Prénom -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Prénom</label>
          <input
            type="text"
            v-model="patient.prenom"
            placeholder="Prénom"
            class="form-control form-control-clinique"
            :class="{ 'is-invalid': error.prenom }"
          />
          <div class="invalid-feedback">{{ error.prenom }}</div>
        </div>
        <!-- Genre -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Genre</label>
          <select
            v-model="patient.genre"
            class="form-select form-select-clinique"
            :class="{ 'is-invalid': error.genre }"
          >
            <option value="" disabled>-- Sélectionnez --</option>
            <option value="Masculin">Masculin</option>
            <option value="Feminin">Feminin</option>
          </select>
          <div class="invalid-feedback">{{ error.genre }}</div>
        </div>
        <!-- Date de naissance -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Date de naissance</label>
          <input
            type="date"
            v-model="patient.dateNaissance"
            class="form-control form-control-clinique"
          />
        </div>
        <!-- Téléphone -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Téléphone</label>
          <input
            type="text"
            v-model="patient.telephone"
            placeholder="Téléphone"
            class="form-control form-control-clinique"
           
          />
          <!-- :class="{ 'is-invalid': error.telephone }"-->
          <!--<div class="invalid-feedback">{{ error.telephone }}</div>-->
        </div>
        <!-- Email -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Email</label>
          <input
            type="email"
            v-model="patient.email"
            placeholder="Email"
            class="form-control form-control-clinique"
          />
        </div>
        <div class="col-md-6">
  <label class="form-label fw-semibold">
    Personne à contacter (urgence)
  </label>
  <input
    type="tel"
    v-model="patient.contactUrgenceTelephone"
    placeholder="Téléphone de la personne à contacter"
    class="form-control form-control-clinique"
  />
</div>
        <!-- Adresse -->
        <div class="col-md-12">
          <label class="form-label fw-semibold">Adresse</label>
          <input
            type="text"
            v-model="patient.adresse"
            placeholder="Adresse"
            class="form-control form-control-clinique"
          />
        </div>
        <!-- Profession -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Profession</label>
          <input
            type="text"
            v-model="patient.profession"
            placeholder="Profession"
            class="form-control form-control-clinique"
          />
        </div>
        
        <!-- Groupe sanguin -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Groupe sanguin</label>
          <select
            v-model="patient.groupeSanguin"
            class="form-select form-select-clinique"
          >
            <option value="" disabled>-- Sélectionnez --</option>
            <option>A+</option>
            <option>A-</option>
            <option>B+</option>
            <option>B-</option>
            <option>AB+</option>
            <option>AB-</option>
            <option>O+</option>
            <option>O-</option>
          </select>
        </div>
        <!-- Antécédents médicaux -->
        <div class="col-md-12">
          <label class="form-label fw-semibold">Antécédents médicaux</label>
          <textarea
            v-model="patient.antecedentsMedicaux"
            placeholder="Ex: diabète, hypertension..."
            class="form-control form-control-clinique"
            rows="2"
          ></textarea>
        </div>
        <!-- Allergies -->
        <div class="col-md-12">
          <label class="form-label fw-semibold">Allergies</label>
          <textarea
            v-model="patient.allergies"
            placeholder="Ex: penicilline, pollen..."
            class="form-control form-control-clinique"
            rows="2"
          ></textarea>
        </div>
        <!-- Assurance -->
        <div class="col-md-4">
          <label class="form-label fw-semibold">Nom de l'assurance</label>
          <input
            type="text"
            v-model="patient.assuranceNom"
            class="form-control form-control-clinique"
            placeholder="Nom de l'assurance"
          />
        </div>
        <div class="col-md-4">
          <label class="form-label fw-semibold">Numéro d’assurance</label>
          <input
            type="text"
            v-model="patient.assuranceNumero"
            placeholder="Numéro assurance"
            class="form-control form-control-clinique"
          />
        </div>
        <div class="col-md-4">
          <label class="form-label fw-semibold">Contact assureur</label>
          <input
            type="text"
            placeholder="contact assurance"
            v-model="patient.assureurContact"
            class="form-control form-control-clinique"
          />
        </div>
        <!-- Statut activé -->
        <div class="col-md-6 d-flex align-items-center mt-3">
          <div class="form-check form-switch">
            <input
              class="form-check-input"
              type="checkbox"
              v-model="patient.isEnabled"
            />
            <label class="form-check-label ms-2 fw-semibold">Activé ?</label>
          </div>
        </div>
      </div>
      <!-- Boutons -->
      <div class="d-flex justify-content-end gap-3 mt-4">
        <button
          class="btn btn-light border shadow-sm px-4 py-2"
          @click="cancel"
        >
          <i class="bi bi-x-circle me-1"></i> Annuler
        </button>
        <button
          class="btn btn-success shadow px-4 py-2 btn-clinique"
          :disabled="isLoading"
          @click="updatePatient"
        >
          <i class="bi bi-save me-1"></i>
          <span v-if="isLoading">Mise à jour...</span>
          <span v-else>Mettre à jour</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  data() {
    return {
      isLoading: false,
      patient: {
        id: null,
        nom: "",
        prenom: "",
        genre: "",
        dateNaissance: "",
        telephone: "",
        email: "",
        adresse: "",
        isEnabled: true,
      },
      error: {
        nom: "",
        prenom: "",
        genre: "",
        telephone: "",
      },
    };
  },
  methods: {
    async loadPatient() {
      try {
        const id = this.$route.params.id;
        const response = await api.getItem("patients", id);
        this.patient = response.data;

        // format date
        if (this.patient.dateNaissance) {
          this.patient.dateNaissance = this.patient.dateNaissance.split("T")[0];
        }
      } catch (err) {
        console.error("Erreur lors du chargement du patient", err);
      }
    },
    validateForm() {
      this.error = {
        nom: this.patient.nom ? "" : "Le nom est requis",
        prenom: this.patient.prenom ? "" : "Le prénom est requis",
        genre: this.patient.genre ? "" : "Le genre est requis",
        //telephone: this.patient.telephone ? "" : "Le téléphone est requis",
      };
      return !Object.values(this.error).some((err) => err !== "");
    },
    async updatePatient() {
      if (!this.validateForm() || this.isLoading) return;
      try {
        this.isLoading = true;
        delete this.patient.createdBy; // au cas où
        await api.updateItem("patients", this.patient.id, this.patient);
        //alert("Patient mis à jour avec succès !");
        this.$router.push({ name: "patients" });
      } catch (err) {
        console.error("Erreur lors de la mise à jour du patient", err);
      } finally {
        this.isLoading = false;
      }
    },
    cancel() {
      this.$router.push({ name: "patients" });
    },
  },
  created() {
    this.loadPatient();
  },
};
</script>

<style scoped>
/* --- Header clinique --- */
.header-clinique {
  padding: 15px 20px;
  background-color: #e9f5ff;
  border-radius: 12px;
  margin-bottom: 20px;
}

/* --- Card formulaire --- */
.card-clinique {
  background: #f8fafd;
  border-radius: 12px;
  border: none;
}

/* --- Champs --- */
.form-control-clinique,
.form-select-clinique {
  border-radius: 10px;
  border: 1px solid #d1e3f0;
  padding: 10px 14px;
  transition: all 0.3s ease;
}
.form-control-clinique:focus,
.form-select-clinique:focus {
  box-shadow: 0 0 6px #0d6efd33;
  border-color: #0d6efd;
}

/* --- Boutons --- */
.btn-clinique {
  background: linear-gradient(90deg, #0d6efd, #6610f2);
  border: none;
  color: #fff;
  border-radius: 10px;
  transition: all 0.3s ease;
}
.btn-clinique:hover {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  transform: translateY(-2px);
}
</style>
